import React, { useEffect, useState } from 'react';
import { CTAButton, SectionHeading } from './ui';
import { CheckCircle2, XCircle, ChevronDown, Shield, Star, Lock, Zap, CreditCard, BookMarked, Trophy } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackPixel } from '../lib/metaPixel';
export function Pricing() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const [selected, setSelected] = useState<'esencial' | 'elite'>('elite');
  const CHECKOUT_URLS = {
    esencial: 'https://biologiafemenina.com.ar/checkouts/cn/hWNDA9skjnOQlMMzGSU3oiA6/es-ar?_r=AQAB9ZSBpJJEhhlzqsFwuw9EvZPJhxl34PyPOwBIZYKf0ic',
    elite: 'https://biologiafemenina.com.ar/checkouts/cn/hWNDA9syw4z1xOFcfgW1tBEQ/es-ar?_r=AQABIGei0dxx1D40LB9yvGqau4DtatlsLP99XSOEqJ7rxQ0'
  };
  const goToCheckout = () => {
    trackPixel('InitiateCheckout', {
      content_name: selected === 'elite' ? 'Megapack Élite' : 'Pack Esencial',
      value: selected === 'elite' ? 27990 : 18990,
      currency: 'ARS'
    });
    window.location.href = CHECKOUT_URLS[selected];
  };
  return <section id="pricing-section" className="py-20 bg-gray-900 text-white" data-id="element-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-17">
        <div className="text-center mb-12" data-id="element-18">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4 text-amber-400" data-id="element-19">
            ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
          </h2>
          <p className="text-xl text-red-400 font-medium mb-8 flex items-center justify-center gap-2" data-id="element-20">
            <span className="w-3 h-3 rounded-full bg-red-500 animate-pulse" data-id="element-21"></span>
            El precio sube cuando termina el contador
          </p>

          <div className="flex justify-center gap-4 text-4xl md:text-5xl font-mono font-bold bg-gray-800 inline-flex p-6 rounded-2xl border border-gray-700 shadow-2xl" data-id="element-22">
            <div className="flex flex-col items-center" data-id="element-23">
              <span data-id="element-24">{timeLeft.hours.toString().padStart(2, '0')}</span>
              <span className="text-xs text-gray-400 mt-2 font-sans" data-id="element-25">HS</span>
            </div>
            <span className="text-gray-500" data-id="element-26">:</span>
            <div className="flex flex-col items-center" data-id="element-27">
              <span data-id="element-28">{timeLeft.minutes.toString().padStart(2, '0')}</span>
              <span className="text-xs text-gray-400 mt-2 font-sans" data-id="element-29">MIN</span>
            </div>
            <span className="text-gray-500" data-id="element-30">:</span>
            <div className="flex flex-col items-center" data-id="element-31">
              <span className="text-amber-400" data-id="element-32">
                {timeLeft.seconds.toString().padStart(2, '0')}
              </span>
              <span className="text-xs text-gray-400 mt-2 font-sans" data-id="element-33">SEG</span>
            </div>
          </div>
        </div>

        <div className="bg-white text-gray-900 rounded-3xl p-6 md:p-10 max-w-2xl mx-auto shadow-2xl" data-id="element-34">
          <div className="text-center mb-8" data-id="element-35">
            <h3 className="text-3xl md:text-4xl font-extrabold mb-3" data-id="element-36">
              Elegí tu Pack:
            </h3>
            <p className="text-gray-500 text-lg" data-id="element-37">
              Ambas opciones incluyen los 6 Bonus estratégicos
            </p>
          </div>

          <div className="space-y-5 mb-8" data-id="element-38">
            {/* Pack Esencial */}
            <button type="button" onClick={() => setSelected('esencial')} className={`w-full text-left rounded-2xl p-5 md:p-6 border-2 transition-all flex items-center gap-4 ${selected === 'esencial' ? 'border-purple-500 bg-purple-50/60 ring-2 ring-purple-200' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-39">
              <span className={`flex-shrink-0 w-7 h-7 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'esencial' ? 'border-purple-600' : 'border-gray-300'}`} data-id="element-40">
                {selected === 'esencial' && <span className="w-3.5 h-3.5 rounded-full bg-purple-600" data-id="element-41" />}
              </span>
              <div className="flex-1" data-id="element-42">
                <div className="flex items-center gap-2 font-extrabold text-lg md:text-xl text-gray-900" data-id="element-43">
                  <BookMarked className="w-5 h-5 text-purple-600" data-id="element-44" /> PACK
                  ESENCIAL
                </div>
                <p className="text-gray-500 text-sm mt-1" data-id="element-45">12 Tomos + 6 Bonus</p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-46">
                <div className="text-gray-400 line-through text-sm" data-id="element-47">
                  $36.990
                </div>
                <div className="text-2xl md:text-3xl font-extrabold text-gray-900" data-id="element-48">
                  $18.990
                </div>
              </div>
            </button>

            {/* Megapack Élite */}
            <button type="button" onClick={() => setSelected('elite')} className={`w-full text-left rounded-2xl p-5 md:p-6 border-2 transition-all flex items-start gap-4 ${selected === 'elite' ? 'border-purple-600 bg-purple-50/80 ring-2 ring-purple-200' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-49">
              <span className={`flex-shrink-0 w-7 h-7 mt-1 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'elite' ? 'border-purple-600' : 'border-gray-300'}`} data-id="element-50">
                {selected === 'elite' && <span className="w-3.5 h-3.5 rounded-full bg-purple-600" data-id="element-51" />}
              </span>
              <div className="flex-1" data-id="element-52">
                <div className="flex items-center gap-2 font-extrabold text-lg md:text-xl text-gray-900 mb-2" data-id="element-53">
                  <Trophy className="w-5 h-5 text-amber-500" data-id="element-54" /> MEGAPACK ÉLITE
                </div>
                <div className="flex flex-wrap gap-2 mb-2" data-id="element-55">
                  <span className="inline-flex items-center gap-1 bg-amber-400 text-amber-950 text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-56">
                    ⭐ MÁS ELEGIDO
                  </span>
                  <span className="inline-flex items-center bg-purple-100 text-purple-700 text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-57">
                    AHORRÁS $18.000
                  </span>
                </div>
                <p className="text-gray-500 text-sm" data-id="element-58">
                  12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-59">
                <div className="text-gray-400 line-through text-sm" data-id="element-60">
                  $49.990
                </div>
                <div className="text-2xl md:text-3xl font-extrabold text-purple-700" data-id="element-61">
                  $27.990
                </div>
              </div>
            </button>
          </div>

          <button onClick={goToCheckout} className={`w-full py-5 rounded-2xl font-extrabold text-lg md:text-xl text-white transition-colors shadow-lg flex items-center justify-center gap-2 ${selected === 'elite' ? 'bg-purple-600 hover:bg-purple-700 shadow-purple-600/30' : 'bg-gray-900 hover:bg-gray-800 shadow-gray-900/30'}`} data-id="element-62">
            {selected === 'elite' ? 'SÍ, QUIERO EL MEGAPACK ÉLITE →' : 'QUIERO EL PACK ESENCIAL →'}
          </button>

          {selected === 'elite' && <p className="text-center text-sm text-gray-500 italic mt-4" data-id="element-63">
              La opción más elegida por mujeres argentinas que quieren solución
              total
            </p>}

          <div className="grid grid-cols-2 gap-4 mt-8 pt-8 border-t border-gray-100 text-sm text-gray-500 font-medium" data-id="element-64">
            <span className="flex items-center gap-2" data-id="element-65">
              <Lock className="w-4 h-4 text-purple-500" data-id="element-66" /> Pago seguro
            </span>
            <span className="flex items-center gap-2" data-id="element-67">
              <Zap className="w-4 h-4 text-amber-500" data-id="element-68" /> Acceso en 5 min
            </span>
            <span className="flex items-center gap-2" data-id="element-69">
              <Shield className="w-4 h-4 text-green-500" data-id="element-70" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-2" data-id="element-71">
              <CreditCard className="w-4 h-4 text-purple-500" data-id="element-72" /> Tarjeta ·
              Transferencia
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function OrderBump() {
  return <section className="py-16 bg-purple-50" data-id="element-73">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-74">
        <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-purple-100" data-id="element-75">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 text-center" data-id="element-76">
            ¿Qué agrega el Megapack Élite?
          </h3>
          <p className="text-center text-gray-600 mb-10 text-lg" data-id="element-77">
            Por solo $9.000 más, pasás de "mejorar" a{' '}
            <span className="font-bold text-purple-700" data-id="element-78">
              "resolver para siempre"
            </span>
            .
          </p>

          <div className="space-y-8" data-id="element-79">
            <div className="flex gap-4 md:gap-6" data-id="element-80">
              <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center text-2xl flex-shrink-0" data-id="element-81">
                ⚡
              </div>
              <div data-id="element-82">
                <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-83">
                  Élite 1 — El Protocolo PH-Shock: El Reinicio de las 12 Horas
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-84">
                  La intervención de emergencia para el Fuego Invisible. Cómo
                  acidificar, desinflamar y blindar tu mucosa antes de que salga
                  el sol. Para la mujer que necesita una solución para mañana,
                  no para el mes que viene.
                </p>
              </div>
            </div>

            <div className="flex gap-4 md:gap-6" data-id="element-85">
              <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center text-2xl flex-shrink-0" data-id="element-86">
                💜
              </div>
              <div data-id="element-87">
                <h4 className="text-xl font-bold text-gray-900 mb-2" data-id="element-88">
                  Élite 2 — Intimidad Sin Miedo: V-Sex Elite
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-89">
                  El protocolo para recuperar el placer y la confianza íntima
                  después de meses de asociar tu zona con dolor, ansiedad y
                  vergüenza. Para la mujer que ya sanó el ecosistema pero
                  todavía no puede disfrutar sin miedo a la factura del día
                  siguiente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
export function Comparison() {
  const rows = [{
    sin: 'Óvulos de farmacia cada mes sin resultado duradero',
    con: 'Protocolo que ataca la raíz del problema'
  }, {
    sin: 'Vergüenza en cada consulta ginecológica',
    con: 'Entendés tu cuerpo y sabés qué está pasando'
  }, {
    sin: 'Oscurecimiento que no mejora con ninguna crema',
    con: 'Efecto Porcelana en 21 días con ingredientes de dietética'
  }, {
    sin: 'Ansiedad antes de cada encuentro íntimo',
    con: 'Protocolo Post-Encuentro que elimina el miedo'
  }, {
    sin: 'Piel áspera e irritada post-depilación',
    con: 'Zona de Seda: suavidad real desde la primera semana'
  }, {
    sin: 'Olor que te genera inseguridad todo el día',
    con: 'Ecosistema equilibrado con aroma neutro natural'
  }, {
    sin: 'Comprando productos equivocados que empeoran todo',
    con: 'Shopping Guide con marcas y lugares exactos'
  }];
  return <section className="py-20 bg-white" data-id="element-90">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <SectionHeading data-id="element-92">¿Cuánto cuesta NO tenerlo?</SectionHeading>

        <div className="overflow-x-auto rounded-2xl shadow-lg border border-gray-200 mb-12" data-id="element-93">
          <table className="w-full text-left border-collapse min-w-[600px]" data-id="element-94">
            <thead data-id="element-95">
              <tr data-id="element-96">
                <th className="bg-red-50 text-red-900 p-6 font-bold text-lg w-1/2 border-b border-red-100" data-id="element-97">
                  Sin Método V-Glow
                </th>
                <th className="bg-green-50 text-green-900 p-6 font-bold text-lg w-1/2 border-b border-green-100" data-id="element-98">
                  Con Método V-Glow
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-99">
              {rows.map((row, i) => <tr key={i} className="hover:bg-gray-50" data-id="element-100">
                  <td className="p-6 text-gray-600 flex items-start gap-3" data-id="element-101">
                    <XCircle className="w-5 h-5 text-red-400 flex-shrink-0 mt-0.5" data-id="element-102" />
                    <span data-id="element-103">{row.sin}</span>
                  </td>
                  <td className="p-6 text-gray-900 font-medium border-l border-gray-100" data-id="element-104">
                    <div className="flex items-start gap-3" data-id="element-105">
                      <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-106" />
                      <span data-id="element-107">{row.con}</span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-108">
          <p className="text-xl text-gray-700 mb-8" data-id="element-109">
            El lunes podés seguir probando remedios de TikTok o empezar con todo
            resuelto.
          </p>
          <p className="text-2xl font-bold text-gray-900 mb-8" data-id="element-110">Vos decidís.</p>
          <CTAButton data-id="element-111">QUIERO EMPEZAR HOY MISMO</CTAButton>
        </div>
      </div>
    </section>;
}
export function Testimonials() {
  const testimonials = [{
    initials: 'MP',
    name: 'María P.',
    city: 'Buenos Aires 🇦🇷',
    text: 'Compré un viernes. El sábado a la mañana ya tenía mi primer protocolo aplicado. El lunes no tenía ni rastro del ardor que me acompañó tres años.'
  }, {
    initials: 'CG',
    name: 'Claudia G.',
    city: 'Córdoba 🇦🇷',
    text: 'El oscurecimiento que tenía por la depilación me daba tanta vergüenza. El Tomo 2 me explicó exactamente qué lo causaba y cómo revertirlo. En 3 semanas vi diferencia real.'
  }, {
    initials: 'SR',
    name: 'Sofía R.',
    city: 'Rosario 🇦🇷',
    text: 'La sección de la ropa interior me cambió la vida. Nunca hubiera pensado que el problema era el lycra que usaba todos los días.'
  }, {
    initials: 'VA',
    name: 'Valentina A.',
    city: 'Mendoza 🇦🇷',
    text: 'El Bonus de Safe Sex me abrió los ojos. Estaba usando un lubricante con glicerina que básicamente le daba de comer a la cándida. Con ese solo cambio, la recurrencia paró.'
  }, {
    initials: 'DA',
    name: 'Daniela A.',
    city: 'Santa Fe 🇦🇷',
    text: 'El Ebook Élite 1 me ayudó a entender el Biofilm. Por eso los óvulos nunca me funcionaban del todo: no llegaban a la raíz. El Protocolo PH-Shock lo cambió todo en una noche.'
  }, {
    initials: 'LR',
    name: 'Laura R.',
    city: 'Tucumán 🇦🇷',
    text: 'Intimidad Sin Miedo me hizo llorar. Porque alguien finalmente puso en palabras lo que me pasaba: que el miedo al día siguiente me estaba quitando las ganas de vivir esa parte de mi vida.'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-112">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <SectionHeading subtitle="4.9/5 ⭐" data-id="element-114">
          Lo que dicen las mujeres que ya lo tienen
        </SectionHeading>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-115">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100" data-id="element-116">
              <div className="flex gap-1 mb-4" data-id="element-117">
                {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-4 h-4 fill-amber-400 text-amber-400" data-id="element-118" />)}
              </div>
              <p className="text-gray-700 mb-6" data-id="element-119">"{t.text}"</p>
              <div className="flex items-center gap-3" data-id="element-120">
                <div className="w-10 h-10 rounded-full bg-purple-100 text-purple-700 flex items-center justify-center font-bold text-sm" data-id="element-121">
                  {t.initials}
                </div>
                <div data-id="element-122">
                  <div className="font-bold text-gray-900 text-sm" data-id="element-123">
                    {t.name}
                  </div>
                  <div className="text-xs text-gray-500" data-id="element-124">{t.city}</div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
export function Guarantee() {
  return <section className="py-16 bg-purple-900 text-white" data-id="element-125">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-126">
        <Shield className="w-16 h-16 text-amber-400 mx-auto mb-6" data-id="element-127" />
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-128">
          Garantía 7 días sin preguntas
        </h2>
        <p className="text-xl text-purple-200 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-129">
          Abrí los 12 Tomos. Revisá los 6 Bonus. Aplicá el Protocolo PH-Shock.
          Usá el V-Sex Elite.
          <br data-id="element-130" />
          <br data-id="element-131" />
          Si no es lo que esperabas →{' '}
          <span className="text-white font-bold" data-id="element-132">100% de devolución.</span> Sin
          preguntas. Sin formularios. Sin drama.
        </p>
        <div className="inline-block bg-purple-800 px-6 py-3 rounded-full font-bold text-purple-200 border border-purple-700" data-id="element-133">
          TASA DE DEVOLUCIONES MENOR AL 2%
        </div>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de confirmar tu pago recibís un email con el enlace de descarga. El acceso es tuyo para siempre, sin suscripción ni vencimiento. Podés descargarlo en tu celular, tablet o computadora.'
  }, {
    q: '¿Sirve si nunca tuve una infección declarada?',
    a: 'Sí. El Método V-Glow está diseñado tanto para mujeres con problemas recurrentes como para mujeres que simplemente quieren mejorar el bienestar, el aroma, la textura y la estética de su zona íntima. El Tomo 1 es el punto de partida para cualquier mujer.'
  }, {
    q: '¿Los 6 Bonus están en las dos opciones?',
    a: 'Sí. Los 6 Bonus estratégicos están incluidos tanto en el Pack Esencial como en el Megapack Élite. La diferencia del Megapack Élite son los 2 Ebooks Élite adicionales: el Protocolo PH-Shock y el V-Sex Elite.'
  }, {
    q: '¿Qué diferencia hay con los remedios caseros que encuentro en internet?',
    a: 'Los remedios caseros de internet son fragmentos de información sin contexto, sin dosis y sin un sistema de aplicación. El Método V-Glow es un sistema completo de 12 protocolos ordenados por problema, con ingredientes específicos, dosis exactas, tablas de compatibilidad y checklists de aplicación. No es información suelta. Es un método.'
  }, {
    q: '¿Sirve si tengo cándida recurrente desde hace años?',
    a: 'Sí, especialmente el Tomo 6 (Bio-Hacking Anti-Cándida) y el Ebook Élite 1 (Protocolo PH-Shock) están diseñados específicamente para la recurrencia crónica. El Tomo 6 trabaja el ciclo sistémico y el Élite 1 te da la intervención de emergencia para los episodios agudos.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 7 días de garantía total. Si abrís todo el material y sentís que no es lo que esperabas, escribinos y te devolvemos el 100% sin preguntas ni formularios.'
  }, {
    q: '¿Vale la pena el Megapack Élite si ya cuido mi zona íntima?',
    a: 'El Megapack Élite está diseñado para la mujer que quiere ir más allá del mantenimiento. El Protocolo PH-Shock es para emergencias reales: resultados en 12 horas. El V-Sex Elite es para la mujer que sanó físicamente pero todavía siente ansiedad o desconexión en la intimidad. Si alguno de los dos describe tu situación, el Megapack Élite es la opción correcta.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, transferencia bancaria y Mercado Pago. El pago es 100% seguro.'
  }];
  return <section className="py-20 bg-white" data-id="element-134">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <SectionHeading data-id="element-136">Preguntas Frecuentes</SectionHeading>
        <div className="space-y-4" data-id="element-137">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-138" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-139">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 flex justify-between items-center transition-colors" data-id="element-140">
        <span className="font-bold text-gray-900" data-id="element-141">{question}</span>
        <ChevronDown className={`w-5 h-5 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-142" />
      </button>
      <AnimatePresence data-id="element-143">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-144">
            <div className="p-6 bg-white text-gray-600 leading-relaxed border-t border-gray-100" data-id="element-145">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function Footer() {
  return <footer className="bg-gray-950 text-gray-400 py-12 text-center" data-id="element-146">
      <div className="max-w-4xl mx-auto px-4" data-id="element-147">
        <div className="text-2xl font-bold text-white mb-6" data-id="element-148">
          💜 MÉTODO V-GLOW
        </div>
        <p className="text-lg text-gray-300 mb-8 italic max-w-2xl mx-auto" data-id="element-149">
          "Porque cuidar tu zona íntima no debería darte vergüenza, costarte una
          fortuna ni ocuparte el domingo entero buscando respuestas en
          internet."
        </p>
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-8 text-sm" data-id="element-150">
          <span data-id="element-151">📧 contacto@metodovglow.com.ar</span>
          <span data-id="element-152">📲 @metodovglow</span>
          <span data-id="element-153">🌐 www.metodovglow.com.ar</span>
        </div>
        <div className="text-xs text-gray-600 border-t border-gray-800 pt-8" data-id="element-154">
          © MÉTODO V-GLOW™ 2026 — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </div>
      </div>
    </footer>;
}